import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteTemplateItem } from "@/adapters/api";

export function useDeleteTemplateItem(templateId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (itemId: string) => {
			if (!templateId) throw new Error("missing template");
			return deleteTemplateItem(templateId, itemId);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["stage-template", templateId],
			});
		},
	});
}
